import { TextField, Chip } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import { Autocomplete } from '@material-ui/lab';
import styled from 'styled-components';
import { HelperTextTip } from '@components/hepler-text-tip';
import { useController } from 'react-hook-form';

export const ControlledAutoCompleteFieldForContentKeywords = ({ name, control, ...props }) => {
  const {
    field: { value, onChange },
  } = useController({ name, control, defaultValue: [] });

  return (
    <GenreStypes>
      <Autocomplete
        multiple
        id="service-master-aka"
        options={[]}
        freeSolo
        value={value}
        onChange={(evt, v) => onChange && onChange(v)}
        // onInputChange={(evt, v) => onChange && onChange(v)}
        renderTags={(value, getTagProps) => {
          return value.map((option, index) => (
            <Chip variant="outlined" label={option} {...getTagProps({ index })} size="small" />
          ));
        }}
        renderInput={params => (
          <TextField
            {...params}
            {...props}
            label="Content Keywords"
            placeholder="Content Keywords"
            helperText={
              <HelperTextTip
                text="Content Keywords"
                tip="[Tip: Hit Enter on the field after entering a new Keyword ]"
              />
            }
          />
        )}
      />
    </GenreStypes>
  );
};
//loading ? 'Keywords (Loading...)' :
const GenreStypes = styled.div`
  .MuiChip-root {
    background: ${blue[600]};
    color: white;
  }
  .MuiChip-deleteIcon {
    color: white;
  }
`;